import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VTextField, {
    attrs: {
      "label": _vm.labelInfo,
      "title": _vm.titleTxt,
      "type": "number",
      "outlined": "",
      "hide-details": "",
      "max": _vm.maxPages,
      "min": "1",
      "dense": ""
    },
    on: {
      "input": function ($event) {
        return _vm.setTablePageOnInput($event);
      }
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = _vm._n($$v);
      },
      expression: "currentPage"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };